import script from "./CustomerService.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerService.vue?vue&type=script&setup=true&lang=js"

import "./CustomerService.vue?vue&type=style&index=0&id=6cd05953&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cd05953"]])

export default __exports__